import {
  FormField,
  type FormFieldProps,
  Input,
  type InputProps,
} from '@moia-dev/pace-web'
import { useId } from 'react'

export type TextfieldProps = Pick<
  FormFieldProps,
  'label' | 'caption' | 'validation' | 'hideCharCount'
> &
  InputProps

export const Textfield = ({
  label,
  name,
  caption,
  id: maybeId,
  validation,
  maxLength,
  value,
  required,
  hideCharCount,
  onChange,
  children,
  ...props
}: TextfieldProps) => {
  const generatedId = useId()
  const id = maybeId ? maybeId : generatedId
  return (
    <FormField
      required={required}
      value={maxLength && typeof value === 'string' ? value : undefined}
      maxLength={maxLength}
      caption={caption}
      label={label}
      htmlFor={id}
      validation={validation}
      hideCharCount={hideCharCount}
    >
      <Input
        id={id}
        {...props}
        required={required}
        onChange={onChange}
        value={value}
        maxLength={maxLength}
        name={name}
      />
    </FormField>
  )
}
